module.exports = __webpack_public_path__ + "static/media/backArrowDisabled.71d98f54.svg";